import { memo } from "react";

interface IProps {
    className?: string;
    content: string;
}

const RichText = ({ className, content }: IProps) => {
    return <div className={className} dangerouslySetInnerHTML={{ __html: content }}></div>;
};

export default memo(RichText);
